var render = function render(){var _vm=this,_c=_vm._self._c;return _c('lifestyle1-template',{attrs:{"cigarette-intake":_vm.cigaretteIntake,"alcohol-intake":_vm.alcoholIntake,"regular-exercise":_vm.regularExercise,"field-errors":_vm.fieldErrors},on:{"field-change":_vm.onFieldChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }